import {Pence} from '../../some-types'
import {BenefitType} from '../PlanBenefit'

export class MrPlanBenefit {
    id: BenefitType
    limit?: Pence
    excess?: Pence
    benefitSpecificExcess?: boolean
}
